import React, { useEffect, useState } from "react";

import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
const AlertMessage = ({
  handleClickOpen,
  setOpen,
  open,
  handlesubmit,
  handleClose,
  data,
}) => {
  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {data.heading}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography gutterBottom>{data.content}</Typography>
        </DialogContent>

        <DialogActions>
          {!data?.closeok ? (
            <Button
              autoFocus
              onClick={handleClose}
              style={{ backgroundColor: "#1c5768", color: "#fff" }}
            >
              Ok
            </Button>
          ) : (
            <></>
          )}
          {data?.showhandlesubmit ? (
            <Button
              autoFocus
              onClick={handlesubmit}
              style={{ backgroundColor: "#1c5768", color: "#fff" }}
            >
              submit
            </Button>
          ) : (
            <></>
          )}
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
};

export default AlertMessage;
